import { observer } from "mobx-react";
import currentPortalStore from "../../../stores/current-portal-store";
import { PLATFORM_DISPLAY_NAME } from "../../../stores/platform-service-store";
import IconBigCommerce from "../icon-bigcommerce/icon-bigcommerce";
import IconCirclePlaceholder from "../icon-circle-placeholder/icon-circle-placeholder";
import IconCustomPlatform from "../icon-custom-platform/icon-custom-platform";
import IconMagento from "../icon-magento/icon-magento";
import IconSalesforce from "../icon-salesforce/icon-salesforce";
import IconShopify from "../icon-shopify/icon-shopify";
import Icon from "../icon/icon";
import OrderStore from "../../../pages/create-rma/stores/order-store";
import { Tooltip } from "../../tooltip/tooltip";
import FontBody1 from "../../fonts/font-body1/font-body1";
import IconReturnNotRefundExchange from "../icon-return-not-refund-exchange/icon-return-not-refund-exchange";
import { FONT_COLOR } from "../../fonts/font-props";
import IconWix from "../icon-wix/icon-wix";

interface IIconPlatformProps {
    orderStore?: OrderStore;
    exchangeTooltipText: string;
}

export function getPlatformIconComponent(platformName?: PLATFORM_DISPLAY_NAME): React.FC {
        platformName = platformName ?? PLATFORM_DISPLAY_NAME.NONE;
        
        switch (platformName) {
            case PLATFORM_DISPLAY_NAME.NONE:
                return () => <IconCirclePlaceholder color="transparent" />;
            case PLATFORM_DISPLAY_NAME.SHOPIFY:
                return IconShopify;
            case PLATFORM_DISPLAY_NAME.MAGENTO:
                return IconMagento;
            case PLATFORM_DISPLAY_NAME.SALESFORCE:
                return IconSalesforce;
            case PLATFORM_DISPLAY_NAME.BIGCOMMERCE:
                return IconBigCommerce;
            case PLATFORM_DISPLAY_NAME.WIX:
                return IconWix;
            default:
                return IconCustomPlatform;
        }
}    

const IconPlatform: React.FC<IIconPlatformProps> = observer(({ orderStore, exchangeTooltipText }) => {

    const PlatformIcon = getPlatformIconComponent(currentPortalStore.platform?.getPlatformDisplayName());
     /** check if the RMA of type exchange */
    const isExchangOrder = orderStore && orderStore.parentOrderIds.length > 0;

    const hasSalesChannel = orderStore && orderStore.salesChannel;

    return (
        <>
            { isExchangOrder ?
                <Tooltip content={<FontBody1 color={FONT_COLOR.NEUTRAL_WHITE}>{exchangeTooltipText}</FontBody1>}>
                    <IconReturnNotRefundExchange />
                </Tooltip>

                /** attempt to take the icon from sales channel */
                :hasSalesChannel ?
                <Tooltip content={orderStore.salesChannel?.name}>
                    <img alt="" className="icon-block" src={orderStore.salesChannel.image} />
                </Tooltip>

                :  /** fallback to platform icon */
                <Icon Component={PlatformIcon} color="var(--color-semantic-3)"/>
            }
        </>
       
    )
})

export default IconPlatform;
